import React from 'react';
import { ReactComponent as IndividualSvg } from './IndividualIcon.svg';

const IndividualIcon = () => <IndividualSvg />;

export default IndividualIcon;
